import { render } from "./HwResultModal.vue?vue&type=template&id=5de6747b&scoped=true"
import script from "./HwResultModal.vue?vue&type=script&lang=js"
export * from "./HwResultModal.vue?vue&type=script&lang=js"

import "./HwResultModal.vue?vue&type=style&index=0&id=5de6747b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de6747b"]])

export default __exports__